import axios from 'axios'
import { config } from '../../Constants'

export const reviewApi = {
  createReview,
  getUserReviews,
  getReviewsPage,
  deleteReview
}

function createReview(user, review) {
  return instance.post('/api/reviews/create', review, {
    headers: {
      'Content-type': 'application/json',
      'Authorization': basicAuth(user)
    }
  })
}

function getUserReviews(user, userId) {
  const url = '/api/reviews/bytarget/' + userId;
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function getReviewsPage(user, offset) {
  const url = '/api/reviews/paged?offset='+offset
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function deleteReview(user, id) {
  return instance.delete(`/api/reviews/${id}`, {
    headers: { 'Authorization': basicAuth(user) }
  })
}
// -- Axios

const instance = axios.create({
  baseURL: config.url.API_BASE_URL
})

// -- Helper functions

function basicAuth(user) {
  return `Basic ${user.authdata}`
}
